import React, { useEffect, useState } from "react";
import gift from "../../../../assets/icons/Gift.png";
import Avatar from "../../../../components/avatar/Avatar";
import getIcon from "../../../../utils/Icon";
import { useDispatch, useSelector } from "react-redux";
import {
    addPromoter,
    updatePromoter,
} from "../../../../store/slices/promoFormSlice";
import api from "../../../../api/promosApi";

const BASE_URL = "https://api.duotetra.quest";

export default function PromoPromouter() {
    const dispatch = useDispatch();
    const promoters = useSelector((state) => state.promoForm.promoters);
    const [link, setLink] = useState(promoters?.[0]?.link || "https://t.me/duotetra");
    const [telegramData, setTelegramData] = useState(promoters?.[0] || null);
    const [loading, setLoading] = useState(false);

    const normalizeTelegramLink = (raw) => {
        let trimmed = raw.trim();

        // алиасы Telegram (telegram.me / telegram.dog / www.) → t.me
        trimmed = trimmed
            .replace(/^https?:\/\/(www\.)?telegram\.me\//i, "https://t.me/")
            .replace(/^https?:\/\/(www\.)?telegram\.dog\//i, "https://t.me/")
            .replace(/^https?:\/\/www\.t\.me\//i, "https://t.me/");

        if (trimmed.startsWith("https://t.me/s/")) {
            return trimmed.replace("https://t.me/s/", "https://t.me/");
        }
        if (trimmed.startsWith("http://t.me/s/")) {
            return trimmed.replace("http://t.me/s/", "https://t.me/");
        }
        if (trimmed.startsWith("@")) {
            return `https://t.me/s/${trimmed.slice(1)}`;
        }
        if (!trimmed.startsWith("http")) {
            return `https://t.me/s/${trimmed}`;
        }

        return trimmed;
    };

    const handleSync = async () => {
        const cleanLink = normalizeTelegramLink(link);

        if (!cleanLink.startsWith("https://t.me/")) {
            console.warn("Неверный формат Telegram-ссылки:", cleanLink);
            return;
        }

        setLoading(true);

        try {
            const data = await api.promosApi.syncTelegramMeta(cleanLink);
            setTelegramData(data);

            const promoterPayload = {
                name: data?.name,
                logo: data?.logo,
                link: cleanLink,
            };

            if (!promoters[0]) {
                dispatch(addPromoter(promoterPayload));
            } else {
                dispatch(updatePromoter({ index: 0, field: "name", value: data.name }));
                dispatch(updatePromoter({ index: 0, field: "logo", value: data.logo }));
                dispatch(updatePromoter({ index: 0, field: "link", value: cleanLink }));
            }
        } catch (e) {
            console.error("❌ Ошибка синхронизации:", e);
            setTelegramData(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (promoters[0]) {
            setTelegramData(promoters[0]);
            setLink(promoters[0].link);
        }
    }, [promoters]);

    return (
        <div className="flex h-[120px] w-full flex-col items-center justify-center rounded-xl border border-white/10 bg-white/[0.04] p-4 backdrop-blur-xl">
            <div className="mt-1 flex w-full flex-row items-center justify-between pl-2">
                <div className="rounded-lg border border-white/10 bg-white/[0.08] px-2 py-0.5 text-sm font-medium text-white/90">
                    5 Add promoter
                </div>
                <button
                    onClick={handleSync}
                    className="text-[11px] text-emerald-400/90 hover:underline disabled:opacity-50"
                    disabled={loading}
                >
                    {loading ? "Syncing..." : "Synchronize"}
                </button>
            </div>

            <div className="flex flex-row justify-center items-center gap-2">
                <img src={gift} alt="gift" className="w-6 h-6" />
                <div className="text-center">
                    Airdrop promo by{" "}
                    {telegramData?.name && (
                        <span className="text-blue-400 font-semibold ml-1">
                            {telegramData.name}
                        </span>
                    )}
                </div>
            </div>

            <div className="w-full flex flex-row items-center justify-center mt-2 gap-6">
                <div className="w-10 h-10">
                    {telegramData?.logo ? (
                        <Avatar icon={`${BASE_URL}${telegramData.logo}`} label="octo" />
                    ) : (
                        <Avatar icon={getIcon("dog")} label="octo" />
                    )}
                </div>

                <div className="flex flex-row items-center">
                    <div className="flex items-center justify-center gap-2">
                        <div
                            contentEditable
                            suppressContentEditableWarning
                            className="min-w-[200px] overflow-hidden max-w-[200px] h-[28px] bg-white/10 text-white text-[11px] px-2 flex items-center justify-center border-l border-blue-500 outline-none"
                            onBlur={(e) => setLink(e.target.innerText)}
                        >
                            {link}
                        </div>
                    </div>
                    <img src={getIcon("telegram")} className="w-5 h-5 ml-4" />
                </div>

                <div className="w-10 h-10 flex flex-col justify-center items-center">
                    <Avatar icon={getIcon("octo")} label="share" />
                    <p className="text-[7px] text-gray-400">bot</p>
                </div>

                <div className="flex flex-row items-center justify-center text-white text-sm">
                    OctopusSQD
                </div>
            </div>
        </div>
    );
}
